import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { SessionProvider } from './auth/session';
import { RouterProvider } from './router';
import { installTheme } from './theme';
import { ToastProvider } from './ui/kit';
import { ClockProvider } from './ui/clock';
import './styles.css';

installTheme();

const root = document.getElementById('root');
if (root) {
  createRoot(root).render(
    <StrictMode>
      <RouterProvider>
        <SessionProvider>
          <ToastProvider>
            <ClockProvider>
              <App />
            </ClockProvider>
          </ToastProvider>
        </SessionProvider>
      </RouterProvider>
    </StrictMode>,
  );
}
